/**
 * Checks if a given ISO datetime string is in the past.
 * @param {string} dateStr - An ISO 8601 datetime string (e.g., "2026-02-24T14:00:00.000Z").
 * @returns {boolean} - True if the datetime is in the past, false otherwise.
 */
export function isPastDate(dateStr) {
  const inputDate = new Date(dateStr);
  const now = new Date();
  return inputDate < now;
}